import React from 'react'
import PushMenu from '../dashboard/PushMenu'
import { connect } from 'react-redux'
import MenuItemsContainer from '../dashboard/MenuItemsContainer'
import { SIDEBAR_CLOSE } from '../../actions/actions'

const SECOND = 1000
const DELAY_BEFORE_SIDEBAR_CLOSE_MS = 10 * SECOND

class Sidebar extends React.Component {
  componentDidMount = () => {
    if (this.props.isSmallBrowser) {
      this.closeSideBarAfter(0)
      return
    }

    this.closeSideBarAfter(DELAY_BEFORE_SIDEBAR_CLOSE_MS)
  }

  closeSideBarAfter = delay => {
    this.timeoutHandle = setTimeout(this.props.dispatchCloseSidebar, delay)
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHandle)
  }

  render() {
    const { sideBarIsOpen, isMobile } = this.props

    return (
      <PushMenu isOpen={sideBarIsOpen} isMobile={isMobile}>
        <MenuItemsContainer />
      </PushMenu>
    )
  }
}

function mapStateToProps(state) {
  return {
    sideBarIsOpen: state.sidebar.isOpen,
    isMobile: state.browser.lessThan.small,
    isSmallBrowser: state.browser.lessThan.large,
  }
}

const actions = {
  dispatchCloseSidebar: () => ({
    type: SIDEBAR_CLOSE,
  }),
}

export default connect(
  mapStateToProps,
  actions
)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/common/Sidebar.js